<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
</div>
<div class="trip-detail-popup">
  <p>Trip Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Truck Category :</div>
      <div class="result">
        {{ tripData.truck_category[0]?.truck_category_name }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Weight :</div>
      <div class="result">{{ tripData.truck_type[0]?.truck_weight }}</div>
    </div>
    <div class="col-sm-6">
      <div class="head">Load Category :</div>
      <div class="result">{{ tripData.material_type }}</div>
    </div>
  </div>
  <div class="row">
    <div class="head">Pickup Date :</div>
    <div class="result">{{ tripData.pickup_date | date : "dd-MM-yyyy" }}</div>
  </div>

  <div class="places">
    <!-- Pickup -->
    <div class="place-row">
      <mat-icon>near_me</mat-icon>
      <div class="place-text">
        <h4>{{ tripData.pickup_details.from_city_name }}</h4>
        {{ tripData.from_complete_address }}
        <div class="result">
          Contact Details: {{ tripData?.pickup_name }} - {{ tripData?.pickup_contact }}
        </div>
      </div>
    </div>
    <!-- Stops -->
    <div class="place-row" *ngFor="let stop of tripData.stops; let i = index">
      <mat-icon>stop_circle</mat-icon>
      <div class="place-text">
        <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
        <div>{{ stop.complete_address }}</div>
        <div class="result">Contact Details: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}</div>
      </div>
    </div>
    <!-- Dropoff -->
    <div class="place-row">
      <mat-icon>location_on</mat-icon>
      <div class="place-text">
        <h4>{{ tripData.dropoff_details?.to_city_name }}</h4>
        <div>{{ tripData.to_complete_address }}</div>
        <div class="result">Contact Details: {{ tripData?.dropoff_name }} - {{ tripData?.dropoff_contact }}</div>
      </div>
    </div>
  </div>

  <!-- LR Details  -->
  <p>Lorry Receipts(LRs)</p>
  <mat-divider></mat-divider>
  <div class="lr-container">
    <div class="lr-card-wrapper">
      <!-- Dynamic LR Cards -->
      <div class="lr-card" *ngFor="let lr of tripData?.elr_details; let i = index">
        <div class="lr-left">
          <div class="lr-title">
            LR No.: {{ lr?.elr_no }}
          </div>

          <div class="lr-sub">
            eway Bill No.: {{ lr.eway_bill_no || '-' }}
          </div>

          <span class="status" [ngClass]="lr.consignor_name || lr.material_name ? 'updated' : 'generated'">
            {{ lr.consignor_name || lr.consignee_name ? 'Updated' : 'Generated' }}
          </span>
        </div>

        <div class="lr-actions">
          <mat-icon *ngIf="
              tripData?.trip_status === 'tripbooked' ||
              tripData?.trip_status === 'tripstarted'
            " class="icon edit" (click)="onEdit(tripData, i)">edit</mat-icon>

          <mat-icon class="icon download" *ngIf="downloadingLRIndex !== i" (click)="DownloadLR(tripData, i)">
            download
          </mat-icon>

          <mat-progress-spinner *ngIf="downloadingLRIndex === i" diameter="22" mode="indeterminate"
            class="download-spinner">
          </mat-progress-spinner>
        </div>
      </div>
    </div>

    <!-- Generate Button -->
    <button *ngIf="
        tripData?.trip_status === 'tripbooked' ||
        tripData?.trip_status === 'tripstarted'
      " class="generate-lr-btn" [disabled]="isGeneratingELR" (click)="generateELR(tripData)">
      <span>
        {{ isGeneratingELR ? 'Generating…' : 'Generate eLR' }}
      </span>
    </button>
  </div>

  <p>Transporter Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Contact Name :</div>
      <div class="result">{{ tripData.truckowner_info[0]?.username }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Contact Number :</div>
      <div class="result">{{ tripData.truckowner_info[0]?.mobile }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Transporter ID :</div>
      <div class="result">{{ tripData.truckowner_info[0]?.truckowner_id }}</div>
    </div>
  </div>
  <p>Truck Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Registration No :</div>
      <div class="result">{{ tripData.truck_info[0]?.truck_number }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Truck Category :</div>
      <div class="result">
        {{ tripData.truck_category[0]?.truck_category_name }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Truck Weight :</div>
      <div class="result">{{ tripData.truck_type[0]?.truck_weight }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Truck Id :</div>
      <div class="result">{{ tripData.truck_info[0]?.truck_id }}</div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Driver Name :</div>
      <div class="result">{{ tripData.driver_info[0]?.username }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Driver Number :</div>
      <div class="result">{{ tripData.driver_info[0]?.mobile }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Driver Id :</div>
      <div class="result">{{ tripData.driver_info[0]?.driver_id }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Driver Known Languages :</div>
      <div class="result">{{ tripData.driver_info[0]?.known_lang }}</div>
    </div>
  </div>
  <p>Price Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Total Tons Loaded:</div>
      <div class="result">{{ tripData.workOrderOtherDetails?.loading_point | number : "1.2-2" }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">Price Per Ton :</div>
      <div class="result">
        ₹ {{ (tripData.workorderInfo[0]?.price_per_ton).toFixed(2) }}
      </div>
    </div>
    <!-- Conditionally render content based on the presence of workorderInfo -->
    <div class="col-sm-3" *ngIf="tripData.workorderInfo">
      <div class="head">
        {{
        tripData.workorderInfo[0]?.pay_as_load_quantity ===
        "unloaded_quantity"
        ? "Unloaded Quantity :"
        : "Loaded Quantity :"
        }}
      </div>
      <div class="result">
        {{
        tripData.workorderInfo[0]?.pay_as_load_quantity ===
        "unloaded_quantity"
        ? (tripData.workOrderOtherDetails?.unloading_point
        | number : "1.2-2")
        : (tripData.workOrderOtherDetails?.loading_point | number : "1.2-2")
        }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Total Price :</div>
      <div class="result">
        ₹
        {{
        selectedCategory * tripData.workorderInfo[0]?.price_per_ton || 0
        | number : "1.2-2"
        }}
      </div>
    </div>
  </div>

  <div class="row mt-2" *ngIf="
      tripData.workorderInfo &&
      tripData.workorderInfo[0]?.pay_as_load_quantity === 'unloaded_quantity' &&
      !tripData.workOrderOtherDetails?.unloading_point
    ">
    <div class="col-sm-12">
      <div class="alert alert-warning" style="background-color: #fff3cd; border-color: #ffeeba; color: #856404; padding: 12px 20px; border-radius: 6px; font-weight: 500; font-size: 14px; display: flex; align-items: center; gap: 8px; margin-top: 10px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px;">info</mat-icon>
        <span>This is a temporary fare calculation based on the loading quantity. The actual fare will be updated after receiving the unloading quantity.</span>
      </div>
    </div>
  </div>
  <p>LR Details</p>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">LR No :</div>
      <div class="result">{{ tripData.workOrderOtherDetails?.lr_number }}</div>
    </div>
    <div class="col-sm-3">
      <div class="head">LR Date :</div>
      <div class="result">
        {{ tripData.workOrderOtherDetails?.lr_date | date : "dd-MM-yyyy" }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Loaded Quantity :</div>
      <div class="result">
        {{ tripData.workOrderOtherDetails?.loading_point | number : "1.2-2" }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Unloaded Quantity :</div>
      <div class="result">
        {{ tripData.workOrderOtherDetails?.unloading_point | number : "1.2-2" }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3">
      <div class="head">Price Per Ton :</div>
      <div class="result">
        ₹ {{ (tripData.workorderInfo[0]?.price_per_ton).toFixed(2) }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Sales Order N0 :</div>
      <div class="result">
        {{ tripData.workOrderOtherDetails?.sales_order_number }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">Tax Invoice No :</div>
      <div class="result">
        {{ tripData.workOrderOtherDetails?.tax_invoice_no }}
      </div>
    </div>
    <div class="col-sm-3">
      <div class="head">DDC No :</div>
      <div class="result">{{ tripData.workOrderOtherDetails?.ddc_no }}</div>
    </div>
  </div>
  <div class="row mb-3 mt-3" *ngIf="tripData.workOrderOtherDetails?.epod_received_on || tripData.workOrderOtherDetails?.physical_pod_received_on || tripData.workOrderOtherDetails?.eway_bill_no">
    <div class="col-sm-3" *ngIf="tripData.workOrderOtherDetails?.epod_received_on">
      <div class="head">ePOD Received On :</div>
      <div class="result">{{ tripData.workOrderOtherDetails?.epod_received_on }}</div>
    </div>
    <div class="col-sm-3" *ngIf="tripData.workOrderOtherDetails?.physical_pod_received_on">
      <div class="head">Physical POD Received On :</div>
      <div class="result">{{ tripData.workOrderOtherDetails?.physical_pod_received_on }}</div>
    </div>
    <div class="col-sm-3" *ngIf="tripData.workOrderOtherDetails?.eway_bill_no">
      <div class="head">E-Way Bill No :</div>
      <div class="result">{{ tripData.workOrderOtherDetails?.eway_bill_no }}</div>
    </div>
  </div>
  <div class="trip_history" *ngIf="tripData.trip_history.length > 0">
    <p>Trip History</p>
    <mat-divider></mat-divider>
  </div>
  <!-- <p>Trip History</p>
  <mat-divider></mat-divider> -->
  <div class="row mb mt-4 mb-4 mr-0 ml-0">
    <div class="location-payment-2" *ngFor="let history of trip_history; let i = index">
      <img src="../../../assets/img/dots.svg" *ngIf="trip_history.length - 1 != i" />
      <img src="../../../assets/img/dot_only.svg" *ngIf="trip_history.length - 1 == i" />
      <span class="places-2">
        <span>
          <h4>{{ history.message }}:</h4>
          <h6>
            {{ history.date | date : "dd MMMM, yyyy" }}
            &nbsp;&nbsp;&nbsp;
            {{ history.date | date : "h:mm a" }}
          </h6>
        </span>
      </span>
    </div>
  </div>

  <div class="col-md-12" *ngIf="['tripbooked', 'tripstarted'].includes(tripData.trip_status)">
    <button type="button" class="button buttonCancel pull-right" (click)="openCancelConfirmation(tripData)">
      Cancel Trip
    </button>
  </div>

  <div class="note_btn" *ngIf="tripData.trip_status == 'completed'">
    <button type="button" class="button buttonBlue" (click)="help()">
      Help
    </button>
    <button type="button" class="button buttonBlue" (click)="consignment(tripData)">
      Consignment Note
    </button>
  </div>
</div>